import api from "../../api"
import { adapterOrganizationSingle, adapterSocialMedia } from "../../utils"
import dayjs from 'dayjs'
import 'dayjs/locale/en'

const subAdapter = {
  guest: {
    responseBodyToRender(internal = [], external = []){
      function adaptSingle(element){
        const {
          nama,
          email,
          telepon,
          pekerjaan = {
            nama: []
          },
          typeDifable = {
            nama: []
          },
          typeGender = {
            nama: []
          },
          nomorTiket,
          pkParticipantEksternalId,
          pkParticipantInternalId
        } = element

        const occupation = pekerjaan !== null ? (pekerjaan.nama[0] ? pekerjaan.nama[0] : '-') : '-'
        const disability = typeDifable !== null ? (typeDifable.nama[0] ? typeDifable.nama[0] : '-') : '-'
        const gender = typeGender !== null ? (typeGender.nama[0] ? typeGender.nama[0] : '-') : '-'
        const id = pkParticipantEksternalId ? pkParticipantEksternalId : pkParticipantInternalId ? pkParticipantInternalId : null
        const type = pkParticipantEksternalId ? 'external' : pkParticipantInternalId ? 'internal' : null
        const phone = telepon ? telepon : '-'

        return {
          name: nama,
          email,
          phone,
          occupation,
          disability,
          gender,
          no: nomorTiket,
          id,
          type
        }
      }

      let output = []

      if(internal.nama){
        output.push(adaptSingle(internal))
      } else if (internal && internal.length > 0) {
        for (let index = 0; index < internal.length; index++) {
          const element = internal[index];
          output.push(adaptSingle(element))
        }
      }

      if(external && external.length > 0){
        for (let index = 0; index < external.length; index++) {
          const element = external[index];
          output.push(adaptSingle(element))
        }
      }

      return output
    }
  }
}

const adapter = {
  accountToIndividuProfile(account, isForm){
    let result = {}

    // Get 'individu' data inside 'account' object
    if(account.individu && account.individu[0]){
      const individu = account.individu[0]

      const status = isForm && individu.statusIndividu && individu.statusIndividu !== null ? individu.statusIndividu.id : individu.statusIndividu
      const statusName = individu.statusIndividu && individu.statusIndividu !== null ? {
        id: individu.statusIndividu.nama[0],
        en: individu.statusIndividu.nama[1]
      } : {
        id: '',
        en: ''
      }

      result = {
        typeAccount: account.typeAccount ? account.typeAccount.id : '',
        accountId: account.accountId,
        id: individu.userId,
        userId: individu.userId,
        name: individu.namaIndividu,
        image: api.base_image+individu.imgFotoProfile,
        content: individu.tentangSaya,
        status,
        statusName,
        institution: individu.institusi,
        email: individu.email,
        gender: {
          label: individu.typeGender?.nama[0],
          value: individu.typeGender?.id,
        },
        disability: {
          label: individu.typeDifable?.nama[0],
          value: individu.typeDifable?.id,
        },
        occupation: {
          label: individu.pekerjaan?.nama[0],
          value: individu.pekerjaan?.id,
        },
        phone: individu.telepon,

        // Social Links for rendering purpose
        socialLinks: adapterSocialMedia.APIToForm(individu.sosialMedia, {}),

        // Social links for profile form's default values purpose
        ...adapterSocialMedia.APIToForm(individu.sosialMedia, {isFlat: true})
      }
    }

    return result
  },

  accountToIndividuProfileInitialForm(account){
    let result = {
      typeAccount: '',
      accountId: '',
      userId: '',
      name: '',
      status: 0,
      institution: '',
      content: '',
    }

    // Get 'individu' data inside 'account' object
    if(account.individu && account.individu[0]){
      const individu = account.individu[0]

      const status = individu.statusIndividu && individu.statusIndividu !== null ? individu.statusIndividu.id : individu.statusIndividu

      result = {
        typeAccount: account.typeAccount ? account.typeAccount.id : '',
        accountId: account.accountId,
        id: individu.userId,
        userId: individu.userId,
        name: individu.namaIndividu,
        image: api.base_image+individu.imgFotoProfile,
        content: individu.tentangSaya,
        status,
        institution: individu.institusi,
        email: individu.email,
        ...adapterSocialMedia.APIToForm(individu.sosialMedia, {isFlat: true})
      }
    }

    return result
  },

  accountToOrganizationProfile(account){
    let result = {}

    if(account.organisasi && account.organisasi[0]){
      const organization = account.organisasi[0]

      result = {
        typeAccount: account.typeAccount ? account.typeAccount.id : '',
        accountId: account.accountId,
        ...adapterOrganizationSingle(organization)
      }
    }

    return result
  },

  accountToOrganizationProfileInitialForm(account){
    let result = {}

    if(account.organisasi && account.organisasi[0]){
      const organization = account.organisasi[0]

      result = {
        typeAccount: account.typeAccount ? account.typeAccount.id : '',
        accountId: account.accountId,
        ...adapterOrganizationSingle(organization)
      }
    }

    return result
  },

  organization: {
    formToRequestBody(input) {
      let output = {};

      if (input) {
        const {
          organization_url,
          organization_name,
          pic_name,
          mission_statement,
          type = [],
          audience = [],
          approach = [],
          issue = [],
          website,
          email,
          password,
          phone,
          phone_org,
          typeAccount = 2,

          city,
          province,
          address,
          pin_point
        } = input;

        output = {
          email,
          password,
          typeAccount,
          namaPenanggungjawabAccount: pic_name,
          telepon: phone,
          namaReferer: "N/A",
          organisasiReferer: "N/A",
          referenceDeclaration: "N/A",
          referalCode: 0,
          organisasi: [
            {
              namaOrganisasi: organization_name,
              namaLink: organization_url,
              tahunBerdiri: 0,
              totalMember: 0,
              emailOrganisasi: email,
              teleponOrganisasi: phone_org,
              missionStatement: mission_statement,
              websiteOrganisasi: website,
              deskripsi: [ "N/A", "N/A" ],
              lokasiOrganisasi: [
                {
                  provinsi: province && province.label ? province.label : 'N/A',
                  kota: city,
                  jalan: address,
                  pinLocation: pin_point
                }
              ],
              sosialMedia: [],
              typeOrganisasi: type.map(d => d.value),
              typeAudience: audience.map(d => d.value),
              typeApproach: approach.map(d => d.value),
              typeIssues: issue.map(d => d.value),
              // visibilityDefault: 1
            },
          ],
          // visibilityDefault: 1
        };
      }

      return output;
    },
  },

  responseBodyToTickets(input = []){
    let output = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const element = input[index];
        const {
          activityParticipantEksternal,
          activityParticipantInternal,
          eventId,
          judulActivity,
          // statusActivity,
          tanggalMulai,
          tanggalSelesai,
          namaOrganisasi,
          imgThumbnail,
          rescheduleNote
        } = element

        if(judulActivity){
          const is_upcoming = dayjs().locale('en').isBefore(tanggalMulai)
          const is_ongoing = dayjs().locale('en').isAfter(tanggalMulai) && dayjs().locale('en').isBefore(tanggalSelesai)
          const is_past = dayjs().locale('en').isAfter(tanggalSelesai)

          const guests = subAdapter.guest.responseBodyToRender(activityParticipantInternal, activityParticipantEksternal)

          output.push({
            event_id: eventId,
            image: api.base_image+imgThumbnail,
            date: dayjs(tanggalMulai).locale('en').format('ddd, MMM DD, h:mm A')/* 'Wed, Jul 31, 6:00 PM' */,
            date_by_language: {
              en: dayjs(tanggalMulai).locale('en').format('ddd, MMM DD, h:mm A'),
              id: dayjs(tanggalMulai).locale('id').format('dddd, DD MMM YYYY, h:mm A')
            },
            // note: 'Free order #996087991 on July 26, 2019',
            organization: namaOrganisasi,
            title: {
              id: judulActivity?.[0],
              en: judulActivity?.[1]
            },
            is_upcoming,
            is_ongoing,
            is_past,
            guests,
            reschedule_note: rescheduleNote
          })
        } else {
          console.error('Field "judulActivity" tidak ditemukan pada response endpoint /eventparticipant.')
        }
      }
    }

    return output
  }
}

export default adapter
